import { QUERY_KEYS } from "@cnx/common";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import MessageService from "services/MessageService";
import { useChatPanelStore } from "stores/chatPanel";
import { getQueryKeysForDiscussionContext } from "utils/chat";

export const useCreateDiscussion = () => {
  const queryClient = useQueryClient();
  const setPanelDiscussionId = useChatPanelStore(
    store => store.setPanelDiscussionId
  );

  const panelContextId = useChatPanelStore(store => store.panelContextId);
  const panelContext = useChatPanelStore(store => store.panelContext);

  const handleDiscussionCreated = useCallback(
    async (newDiscussionId: string) => {
      await queryClient.fetchQuery({
        queryKey: [QUERY_KEYS.MESSAGES, newDiscussionId],
        queryFn: () =>
          MessageService.fetchMessagesByDiscussionId({
            discussionId: newDiscussionId,
          }),
      });

      setPanelDiscussionId(
        newDiscussionId,
        panelContextId ?? null,
        panelContext ?? null
      );

      const contextQueryKeys = panelContext
        ? getQueryKeysForDiscussionContext(panelContext)
        : undefined;
      await Promise.all([
        ...(contextQueryKeys ?? []).map(qk =>
          queryClient.invalidateQueries({ queryKey: qk })
        ),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.DISCUSSION_CONTEXT],
        }),
      ]);
    },
    [queryClient, setPanelDiscussionId, panelContextId, panelContext]
  );

  return {
    onDiscussionCreated: handleDiscussionCreated,
  };
};
